import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import SliderProps from './SliderProps'

import Tooltip from '../Common/Tooltip'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: SliderProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Tooltip
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoSlider(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            var kendoWidget = that.kendoWidget()
            var inputElement = kendoWidget.element
            if(that.v3){
                that.$emit('update:modelValue', inputElement.val())
            } else {
                that.$emit('changemodel', inputElement.val())
            }
        })

        that.kendoWidget().bind('slide', function(){
            var kendoWidget = that.kendoWidget()
            var inputElement = kendoWidget.element
            if(that.v3){
                if(that.getListeners()['onUpdate:modelValue']){
                    that.$emit('update:modelValue', inputElement.val())
                }
            } else {
                that.$emit('changemodel', inputElement.val())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSlider()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/KendoSliderMixin.js